import { Component, Output, Input, EventEmitter } from '@angular/core';
import { PcdfSearchManual371Service } from 'src/rdsap/services/pcdf/pcdf-search-manual371.service';

@Component({
  selector: 'app-pcdb-manual-weather-compensation',
  templateUrl: './pcdb-manual-weather-compensation.component.html'
})
export class PcdbManualWeatherCompensationComponent {
  result: any;
  selectedPcdbData: any[] = [];
  @Output() onSelectData = new EventEmitter<any>(); 
  @Input() headers = [
    { key: 'brandName', label: 'Brand name' },
    { key: 'modelName', label: 'Model name' },
    { key: 'modelQualifier', label: 'Model Qualifier' },
    { key: 'select', label: 'Select' },
  ];

  constructor(private pcdfSearchManual371Service: PcdfSearchManual371Service) {}

  ngOnInit(): void {
    this.result = this.pcdfSearchManual371Service.viewPcdbWeatherCompensationData();
  }

  selectPcdbData(data) {
    const checked = data.selected;
    const existData = this.selectedPcdbData.findIndex(item => item.indexNumber === data.id);
    if(checked && existData < 0) {
        this.selectedPcdbData = [...this.selectedPcdbData, {
          indexNumber: data.id,
        }];
    } else if(!checked && existData >= 0) {
      this.selectedPcdbData.splice(existData, 1);
    } else if(checked && existData >= 0) {
      this.selectedPcdbData[existData] = {
        indexNumber: data.id,
      };
    }
    this.onSelectData.emit(this.selectedPcdbData);
  }
}
